var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7ZM14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7ZM5.798 5.09089C5.60274 4.89563 5.28615 4.89563 5.09089 5.09089C4.89563 5.28615 4.89563 5.60274 5.09089 5.798L6.29289 7L5.09089 8.202C4.89563 8.39726 4.89563 8.71385 5.09089 8.90911C5.28615 9.10437 5.60274 9.10437 5.798 8.90911L7 7.70711L8.202 8.90911C8.39726 9.10437 8.71385 9.10437 8.90911 8.90911C9.10437 8.71385 9.10437 8.39726 8.90911 8.202L7.70711 7L8.90911 5.798C9.10437 5.60274 9.10437 5.28615 8.90911 5.09089C8.71385 4.89563 8.39726 4.89563 8.202 5.09089L7 6.29289L5.798 5.09089Z",
    fill: "#FF5151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.5da053ca81f290caa3b020baaf16227f.svg";
export { ForwardRef as ReactComponent };